'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsAccessibility = require('@bibliocommons/utils-accessibility');

require('../styles/PopupManager.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ESCAPE_KEY = 27;

var PopupManager = function (_BcReactComponent) {
  _inherits(PopupManager, _BcReactComponent);

  function PopupManager(props) {
    _classCallCheck(this, PopupManager);

    var _this = _possibleConstructorReturn(this, (PopupManager.__proto__ || Object.getPrototypeOf(PopupManager)).call(this, props));

    _this.state = {
      expanded: props.initialOpenState
    };

    _this.triggerRef = null;
    _this.wrapperRef = null;

    _this.bindAll('setWrapperRef', 'setTriggerRef', 'setPopupRef', 'handleClickOutside', 'handleKeyboardAction', 'toggleContent', 'closeContent', 'openContent', 'focusContent', 'closeAndFocusContent');

    _this.popupActions = {
      openContent: _this.openContent,
      closeContent: _this.closeContent,
      focusContent: _this.focusContent,
      toggleContent: _this.toggleContent,
      closeAndFocusContent: _this.closeAndFocusContent
    };
    return _this;
  }

  _createClass(PopupManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.expanded) {
        document.addEventListener('click', this.handleClickOutside);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keypress', this.handleKeyboardAction);
    }
  }, {
    key: 'closeContent',
    value: function closeContent() {
      var _this2 = this;

      var doFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.setState({ expanded: false }, function () {
        document.removeEventListener('click', _this2.handleClickOutside);
        document.removeEventListener('keydown', _this2.handleKeyboardAction);
        if (doFocus) {
          _this2.focusContent();
        }
      });
    }
  }, {
    key: 'focusContent',
    value: function focusContent() {
      var _this3 = this;

      setTimeout(function () {
        var isActiveElementInPage = !!document.activeElement && document.activeElement !== document.body;
        if (!isActiveElementInPage) {
          (0, _utilsAccessibility.setFocusWithinElement)(_this3.triggerRef);
        }
      }, 0);
    }
  }, {
    key: 'closeAndFocusContent',
    value: function closeAndFocusContent() {
      this.closeContent(true);
    }
  }, {
    key: 'openContent',
    value: function openContent() {
      var _this4 = this;

      this.setState({ expanded: true }, function () {
        document.addEventListener('click', _this4.handleClickOutside);
        document.addEventListener('keydown', _this4.handleKeyboardAction);
        (0, _utilsAccessibility.setFocusWithinElement)(_this4.popupRef);
      });
    }
  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: 'setTriggerRef',
    value: function setTriggerRef(node) {
      this.triggerRef = node;
    }
  }, {
    key: 'setPopupRef',
    value: function setPopupRef(node) {
      this.popupRef = node;
    }
  }, {
    key: 'toggleContent',
    value: function toggleContent() {
      if (this.state.expanded) {
        this.closeContent();
      } else {
        this.openContent();
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      var wrapper = this.props.closeOnClick ? this.triggerRef : this.wrapperRef;
      if (wrapper && !wrapper.contains(event.target)) {
        this.closeAndFocusContent();
      }
    }
  }, {
    key: 'handleKeyboardAction',
    value: function handleKeyboardAction(event) {
      // close on escape
      if (event.keyCode === ESCAPE_KEY) {
        this.closeAndFocusContent();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-popup-manager ' + this.props.className, ref: this.setWrapperRef },
        _react2.default.createElement(
          'div',
          { className: 'trigger-wrapper', ref: this.setTriggerRef },
          this.props.children(this.popupActions, this.state.expanded)
        ),
        this.state.expanded ? _react2.default.createElement(
          'span',
          { ref: this.setPopupRef },
          this.props.renderContent(this.popupActions)
        ) : null
      );
    }
  }]);

  return PopupManager;
}(_baseBcReactComponent2.default);

PopupManager.propTypes = {
  renderContent: _react.PropTypes.func.isRequired,
  initialOpenState: _react.PropTypes.bool,
  closeOnClick: _react.PropTypes.bool
};

PopupManager.defaultProps = {
  initialOpenState: false,
  closeOnClick: true
};

exports.default = PopupManager;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-popup-manager/lib/components/PopupManager.component.js
// module id = 696
// module chunks = 0 1 10 11 12